<script setup lang="ts">
import IconEarthArrowLeft from '~icons/mdi/earth-arrow-left'

interface Props {
  labelKey: string
  tooltipKey: string
  size?: 'x-small' | 'small' | 'default'
}

const props = withDefaults(defineProps<Props>(), {
  size: 'small',
})
</script>

<template>
  <v-tooltip
    location="bottom"
    max-width="320"
  >
    <span :data-test-id="`product-attribute-tooltip-${labelKey}`">{{ $t(tooltipKey) }}</span>
    <template #activator="{ props: tooltipProps }">
      <v-chip
        v-bind="tooltipProps"
        :size="props.size"
        class="mt-1"
        :prepend-icon="IconEarthArrowLeft"
        :data-test-id="`product-attribute-chip-${labelKey}`"
      >
        {{ $t(labelKey) }}
      </v-chip>
    </template>
  </v-tooltip>
</template>
